import { useCallback } from 'react';

import { captureEvent } from '@/services/analytics';

import { useUserDetails } from '@/features/_shared/user';
import isAiMessage from '@/features/ai-chat/lib/isAiMessage';
import isHumanMessage from '@/features/ai-chat/lib/isHumanMessage';
import { clock } from '@/services/clock';

import type { UIMessage } from '@tanstack/ai-client';

export function useChatAnalytics(
  conversationId: string | null,
  messagesRef: React.RefObject<UIMessage[]>
) {
  const { userEmail } = useUserDetails();

  return useCallback(() => {
    if (!conversationId) return;
    const humanMsg = messagesRef.current.at(-2);
    const aiMsg = messagesRef.current.at(-1);
    if (!isHumanMessage(humanMsg) || !isAiMessage(aiMsg)) return;
    const promptPart = humanMsg.parts.find(p => p.type === 'text');
    captureEvent('ai_conversation', {
      timestamp: clock.date().toISOString(),
      source: 'gxgo',
      conversation_id: conversationId,
      email: userEmail,
      prompt: promptPart?.content ?? '',
      response: aiMsg.parts
    });
  }, [conversationId, userEmail, messagesRef]);
}
